import React from 'react'
// eslint-disable-next-line react/prop-types
const TableArrowDown =({className, onClick, active, reverse, hide}) =>

reverse ? <svg width="8.33" style={{color: active ? '#41A017' : '#BAB6BD', display: hide && 'none' }} className={className} onClick={onClick} height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0L4 5L8 0H0Z" fill={active ? "#41A017" : "#BAB6BD"} />
</svg> :
<svg  width="8.33" style={{color: active ? '#41A017' : '#BAB6BD', rotate:'180deg', display: hide && 'none'}} className={className} onClick={onClick} height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0L4 5L8 0H0Z" fill={active ? "#41A017" : "#BAB6BD"} />
</svg>


export default TableArrowDown
